import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitoratnagiricab() {



    const cardData = {

keyword: "Mumbai to Ratnagiri Cab",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Mumbai to Ratnagiri Cab services for coastal travel, family vacations, weekend getaways, and one-way or round-trip journeys. We provide a wide range of well-maintained vehicles including Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus with professional and experienced chauffeurs. With 24x7 availability, transparent pricing, doorstep pickup in Mumbai, and safe highway driving through the scenic Konkan route, we ensure a smooth, comfortable, and hassle-free travel experience to Ratnagiri.",

topPlaces: [
    {
        title: "Ganpatipule Beach & Temple",
        description:
            "Ganpatipule is one of the most famous coastal pilgrimage destinations near Ratnagiri, known for its pristine beach and the revered Swayambhu Ganpati Temple."
    },
    {
        title: "Ratnadurg Fort",
        description:
            "Ratnadurg Fort is a historic sea fort overlooking the Arabian Sea, offering panoramic coastal views and rich Maratha heritage significance."
    },
    {
        title: "Thibaw Palace",
        description:
            "Thibaw Palace is a royal heritage structure built for the exiled king of Burma, known for its historical architecture and museum displays."
    },
    {
        title: "Aare-Ware Beach",
        description:
            "Aare-Ware Beach is a twin beach stretch known for clean shores, blue waters, and scenic sunset views along the Konkan coastline."
    },
    {
        title: "Mandavi Beach",
        description:
            "Mandavi Beach is a popular beach in Ratnagiri city offering relaxing seaside views, local food stalls, and calm waters for visitors."
    },
    {
        title: "Jaigad Fort & Lighthouse",
        description:
            "Jaigad Fort is a historic fort located at the meeting point of the river and sea, offering stunning views and a nearby lighthouse attraction."
    },
    {
        title: "Pawas",
        description:
            "Pawas is a peaceful spiritual village near Ratnagiri known for Swami Swaroopanand Ashram and its calm natural surroundings."
    },
    {
        title: "Marleshwar Waterfall & Temple",
        description:
            "Marleshwar is famous for its waterfall and cave temple dedicated to Lord Shiva, surrounded by dense forest and scenic beauty."
    },
    {
        title: "Bhatye Beach",
        description:
            "Bhatye Beach is a clean and peaceful beach near Ratnagiri city, ideal for family outings and sunset views."
    },
    {
        title: "Prachin Konkan Museum",
        description:
            "Prachin Konkan Museum showcases traditional Konkan culture, lifestyle, and history through life-size exhibits and village settings."
    }
],



services: [
{
name: "Mumbai to Ratnagiri Cab",
description: "Mumbai Airport Cab offers Mumbai to Ratnagiri Cab service for safe, comfortable, and reliable travel to the beautiful Konkan coastal city of Ratnagiri. Whether you are travelling for family vacation, beach holiday, business visit, tourism, or weekend getaway, we provide well-maintained vehicles including Sedan, SUV, Innova, Innova Crysta, Kia Carens, Tempo Traveller, and luxury cars. Our professional chauffeurs are experienced in Konkan highway and ghat routes, ensuring smooth driving, timely pickup, passenger safety, and a stress-free journey. With doorstep pickup from Mumbai, flexible travel planning, transparent pricing, luggage assistance, and 24x7 support, we make your coastal journey comfortable and enjoyable."
},
{
name: "Mumbai to Ratnagiri Taxi",
description: "Mumbai to Ratnagiri Taxi service by Mumbai Airport Cab provides dependable intercity transportation with clean, air-conditioned vehicles and experienced chauffeurs. Ideal for families and tourists visiting Ratnagiri, we ensure safe highway travel, punctual pickup, and comfortable seating for a smooth coastal journey from Mumbai."
},
{
name: "Mumbai to Ratnagiri Cab Fare",
description: "Mumbai to Ratnagiri Cab Fare with Mumbai Airport Cab is transparent, affordable, and based on vehicle type, distance, and travel requirements. We provide clear pricing with no hidden charges and flexible options for one-way and round-trip journeys, ensuring cost-effective coastal travel with comfort and reliability."
},
{
name: "Mumbai to Ratnagiri Car Rental",
description: "Mumbai Airport Cab offers Mumbai to Ratnagiri Car Rental service with chauffeur-driven vehicles for long-distance coastal travel. Our fleet includes comfortable sedans and spacious SUVs ideal for family trips, tourism, and group travel. We ensure safe driving, luggage support, and flexible itineraries for a smooth travel experience."
},
{
name: "Mumbai to Ratnagiri One Way Cab",
description: "Mumbai to Ratnagiri One Way Cab service provides affordable travel for passengers who require a single journey without return charges. Mumbai Airport Cab ensures transparent pricing, comfortable vehicles, and professional chauffeurs for intercity travel, tourism, and relocation needs."
},
{
name: "Mumbai to Ratnagiri Outstation Cab",
description: "Mumbai to Ratnagiri Outstation Cab service offers reliable long-distance transportation with well-maintained vehicles and experienced drivers. Mumbai Airport Cab ensures safe highway driving, flexible schedules, and comfortable seating for stress-free intercity coastal journeys."
},
{
name: "Mumbai to Ratnagiri Konkan Cab",
description: "Mumbai to Ratnagiri Konkan Cab service is specially designed for scenic coastal travel through the beautiful Konkan region. Mumbai Airport Cab ensures comfortable vehicles, experienced drivers, and smooth driving through highways and coastal routes for an enjoyable journey experience."
},
{
name: "Mumbai to Ratnagiri Beach Cab",
description: "Mumbai to Ratnagiri Beach Cab service provides dedicated transportation for travelers visiting Ratnagiri beaches and coastal attractions. Mumbai Airport Cab ensures safe travel, comfortable vehicles, and flexible schedules for a relaxing beach holiday experience."
},
{
name: "Mumbai to Ratnagiri Family Cab",
description: "Mumbai to Ratnagiri Family Cab service provides safe and comfortable transportation for families travelling together. Mumbai Airport Cab ensures spacious vehicles, experienced drivers, luggage-friendly travel, and flexible booking options for a stress-free coastal vacation."
},
{
name: "Mumbai to Ratnagiri Innova Cab",
description: "Mumbai Airport Cab offers Mumbai to Ratnagiri Innova Cab service for families and groups needing spacious and comfortable travel. Our Innova vehicles provide ample seating, luggage space, and smooth ride quality, making long coastal journeys more relaxing and convenient."
},
{
name: "Mumbai to Ratnagiri SUV Cab",
description: "Mumbai to Ratnagiri SUV Cab service provides powerful and comfortable vehicles suitable for highway and coastal travel. Mumbai Airport Cab ensures safe driving, spacious interiors, and smooth journey experience for families and groups travelling together."
},
{
name: "Mumbai to Ratnagiri Round Trip Cab",
description: "Mumbai to Ratnagiri Round Trip Cab service offers complete return journey solutions for family vacations, business trips, and tourism. Mumbai Airport Cab ensures flexible scheduling, professional chauffeurs, and comfortable vehicles for a smooth round trip experience."
},
{
name: "Mumbai to Ratnagiri Travel Service",
description: "Mumbai to Ratnagiri Travel Service provides complete transportation solutions for families, tourists, and business travellers. Mumbai Airport Cab ensures safe, comfortable, and well-organized coastal travel with flexible itineraries and professional drivers."
},
{
name: "Mumbai to Ratnagiri Weekend Cab",
description: "Mumbai to Ratnagiri Weekend Cab service offers quick getaway travel solutions for short holidays and beach trips. Mumbai Airport Cab ensures flexible booking, comfortable vehicles, and reliable chauffeurs for a smooth weekend escape to Ratnagiri."
},
{
name: "Mumbai to Ratnagiri Scenic Cab",
description: "Mumbai to Ratnagiri Scenic Cab service is designed for travelers who want to enjoy the beautiful Konkan landscapes, coastal views, and greenery during the journey. Mumbai Airport Cab ensures smooth driving and comfortable travel experience throughout the scenic route."
},
{
name: "Mumbai to Ratnagiri Highway Cab",
description: "Mumbai to Ratnagiri Highway Cab service ensures safe and efficient long-distance travel across major highway routes. Mumbai Airport Cab provides experienced chauffeurs, optimized routes, and well-maintained vehicles for smooth intercity coastal journeys."
},
{
name: "Mumbai to Ratnagiri Budget Cab",
description: "Mumbai to Ratnagiri Budget Cab service offers economical travel solutions without compromising safety or comfort. Mumbai Airport Cab ensures affordable pricing, clean vehicles, and reliable drivers for cost-effective coastal travel."
},
{
name: "Mumbai to Ratnagiri Tour Cab",
description: "Mumbai to Ratnagiri Tour Cab service offers customized travel packages for sightseeing and holiday trips. Mumbai Airport Cab ensures comfortable vehicles, flexible itineraries, and reliable service for a smooth and enjoyable Ratnagiri tour experience."
},
{
name: "Mumbai to Ratnagiri Night Travel Cab",
description: "Mumbai to Ratnagiri Night Travel Cab service provides safe and reliable overnight transportation for long-distance travelers. Mumbai Airport Cab ensures experienced drivers, secure travel conditions, and comfortable vehicles for peaceful night journeys."
}
],

tableData: [
["Mumbai to Ratnagiri Cab","Mumbai to Ratnagiri Taxi"],
["Mumbai to Ratnagiri Cab Fare","Mumbai to Ratnagiri Car Rental"],
["Mumbai to Ratnagiri One Way Cab","Mumbai to Ratnagiri Outstation Cab"],
["Mumbai to Ratnagiri Konkan Cab","Mumbai to Ratnagiri Beach Cab"],
["Mumbai to Ratnagiri Family Cab","Mumbai to Ratnagiri Innova Cab"],
["Mumbai to Ratnagiri SUV Cab","Mumbai to Ratnagiri Round Trip Cab"],
["Mumbai to Ratnagiri Travel Service","Mumbai to Ratnagiri Weekend Cab"],
["Mumbai to Ratnagiri Scenic Cab","Mumbai to Ratnagiri Highway Cab"],
["Mumbai to Ratnagiri Budget Cab","Mumbai to Ratnagiri Tour Cab"]
],












whychoose: [
    {
        WhyChooseheading: "Reliable Mumbai to Ratnagiri Cab Service",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable Mumbai to Ratnagiri Cab services for families, tourists, business travelers, Konkan visitors, and holiday travelers seeking comfortable transportation."
    },
    {
        WhyChooseheading: "Perfect Gateway to Konkan Region",
        WhyChoosedescription: "Ratnagiri is one of Maharashtra's most popular coastal destinations known for beautiful beaches, historical forts, mango orchards, and scenic Konkan landscapes."
    },
    {
        WhyChooseheading: "Comfortable Coastal Road Journey",
        WhyChoosedescription: "Enjoy a relaxing drive through picturesque highways, lush greenery, coastal villages, and breathtaking Konkan views while traveling from Mumbai to Ratnagiri."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles according to passenger count and travel requirements."
    },
    {
        WhyChooseheading: "One-Way and Round Trip Facilities",
        WhyChoosedescription: "Whether you require a one-way transfer, round trip, weekend getaway package, or customized Konkan tour, we offer flexible travel solutions."
    },
    {
        WhyChooseheading: "Pickup Available Across Mumbai",
        WhyChoosedescription: "Doorstep pickup services are available from Mumbai Airport, Navi Mumbai, Thane, Dombivli, Kalyan, Andheri, Borivali, Bandra, Dadar, Powai, and nearby locations."
    },
    {
        WhyChooseheading: "Experienced Drivers for Konkan Routes",
        WhyChoosedescription: "Our professional chauffeurs are familiar with coastal highways and Konkan travel routes, ensuring a safe, smooth, and enjoyable journey."
    },
    {
        WhyChooseheading: "Ideal for Families, Tourists, and Groups",
        WhyChoosedescription: "From family vacations and beach holidays to corporate outings and group tours, we provide suitable vehicles for every travel requirement."
    }
]
};

const faqData = [
    {
        question: "Why do travelers book Mumbai to Ratnagiri Cabs?",
        answer: "Ratnagiri is famous for Ganpatipule Beach, Ratnadurg Fort, Thiba Palace, Alphonso mangoes, and scenic Konkan tourism attractions."
    },
    {
        question: "Can I book a one-way cab from Mumbai to Ratnagiri?",
        answer: "Yes, one-way cab services are available along with round-trip and customized Konkan travel packages."
    },
    {
        question: "Which vehicle is suitable for Mumbai to Ratnagiri travel?",
        answer: "Sedan cars, Ertiga, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, and Mini Buses are available according to passenger count and travel preferences."
    },
    {
        question: "Do you provide weekend and holiday packages?",
        answer: "Yes, customers can book weekend getaways, family vacations, Konkan tours, and customized holiday packages."
    },
    {
        question: "Can families travel comfortably to Ratnagiri?",
        answer: "Yes, we provide spacious and comfortable vehicles suitable for families, senior citizens, and children."
    },
    {
        question: "Are Tempo Travellers available for group travel?",
        answer: "Yes, Tempo Travellers and Mini Buses are available for family groups, corporate teams, and tourist groups."
    },
    {
        question: "Can I visit Ganpatipule during the trip?",
        answer: "Yes, customers can customize their itinerary and include Ganpatipule Temple, Ratnadurg Fort, Aare Ware Beach, Thiba Palace, and other attractions."
    },
    {
        question: "Can I get pickup from Mumbai Airport?",
        answer: "Yes, pickup services are available from Mumbai Airport, hotels, railway stations, offices, and residential locations."
    },
    {
        question: "Is advance booking recommended for Ratnagiri travel?",
        answer: "Yes, advance booking is recommended, especially during holidays, summer vacations, Ganesh Festival, and tourist seasons."
    },
    {
        question: "How can I book a Mumbai to Ratnagiri Cab?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Prakash Sawant",
        feedback:
            "Our Konkan family vacation was wonderful thanks to Mumbai Airport Cabs. The vehicle was comfortable, the driver was familiar with the coastal routes, and the journey was extremely enjoyable.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Shilpa Patankar",
        feedback:
            "We booked a cab for Ratnagiri and Ganpatipule sightseeing. The service was excellent, the cab was clean and spacious, and the entire trip was managed professionally.",
        rating: 5
    }
];
































   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];









const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Mumbai to Ratnagiri Cab",
"image": "https://www.mumbaiairportcabs.com/assets/images/mumbai-to-ratnagiri-cab.jpg",
"description": "Book Mumbai to Ratnagiri cab service for Konkan travel, beach trips, family vacations, and outstation journeys. Mumbai Airport Cabs offers safe and comfortable taxi service with professional drivers, one-way and round-trip options, and 24x7 availability.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/mumbai-to-ratnagiri-cab"
}
};





    return (
        <div>

<Helmet>
  <title>Mumbai to Ratnagiri Cab | Konkan Taxi Service | +91 9545731161</title>

<meta
 name="description"
 content="Book Mumbai to Ratnagiri cab for Konkan travel, beach trips, and outstation journeys. Comfortable taxi service with professional drivers, flexible one-way and round-trip options, and 24x7 availability."
/>

<meta
 name="keywords"
 content="mumbai to ratnagiri cab, mumbai to ratnagiri taxi, mumbai to ratnagiri cab fare, mumbai to ratnagiri car rental, mumbai to ratnagiri one way cab, mumbai to ratnagiri outstation cab, mumbai to ratnagiri konkan cab, mumbai to ratnagiri beach cab"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>












            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/46.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitoratnagiricab;